import cloneDeep from 'lodash.clonedeep';
import {
  ReceiptCausal,
  ReceiptEntry,
  ReceiptRequest,
  ReceiptResponse,
} from '../../interfaces/receipts';
import { ProductType } from '../../interfaces/orders';

// Utility necessarie per consistenza nel backend, dove la voce QUOTA_ISCRIZIONE non è stata rinominata per non compromettere le ricevute già emesse

export const receiptToBackend = (receiptValues: ReceiptRequest) => {
  let convertedReceipt = cloneDeep(receiptValues);

  if (
    convertedReceipt &&
    convertedReceipt.entries &&
    convertedReceipt.entries.length > 0 &&
    convertedReceipt.entries.some(entry => entry.causal === 'SPESA_AMMINISTRATIVA')
  ) {
    convertedReceipt.entries.forEach((entry: any) => {
      if (entry.causal === 'SPESA_AMMINISTRATIVA') {
        entry.causal = 'QUOTA_ISCRIZIONE';
      }
    });
  }

  return convertedReceipt;
};

export const formatReceiptFromBackend = (storedReceipt: ReceiptResponse) => {
  let originalReceipt = cloneDeep(storedReceipt.attributes);

  if (
    originalReceipt &&
    originalReceipt.entries &&
    originalReceipt.entries.length > 0
  ) {
    originalReceipt.entries.forEach((entry: any) => {
      if (entry.causal === 'QUOTA_ISCRIZIONE') {
        entry.causal = 'SPESA_AMMINISTRATIVA';
      }
    });
  }

  return originalReceipt;
};

export const getTreasuryDisplayEntries = (
  receipt: ReceiptResponse
): ReceiptEntry[] => {
  const entries = receipt.attributes.entries || [];
  const hasCourseFeeSplit = entries.some((entry: any) =>
    ['QUOTA_ISCRIZIONE', 'SPESA_AMMINISTRATIVA'].includes(entry.causal)
  );

  if (hasCourseFeeSplit) return entries;

  const courseOrder = receipt.attributes.orders?.data?.find((order: any) => {
    const attributes = order.attributes || order;
    return attributes.productType === ProductType.COURSE;
  }) as any;
  const courseAttributes =
    courseOrder?.attributes?.course?.data?.attributes ||
    courseOrder?.course?.data?.attributes;
  const administrationAmount = Number(
    courseAttributes?.headquarterBalance?.administrations?.estimatedPriceUnit || 0
  );

  if (!courseAttributes || administrationAmount <= 0) return entries;

  return entries.flatMap((entry: any) => {
    if (entry.causal !== ReceiptCausal.QUOTA_CORSO) return entry;

    const entryAmount = Number(entry.amount || 0);
    const splitAdministrationAmount = Math.min(administrationAmount, entryAmount);

    return [
      {
        ...entry,
        amount: Math.max(entryAmount - splitAdministrationAmount, 0),
        costCenter: courseAttributes.courseFee,
        causal: ReceiptCausal.QUOTA_CORSO,
      },
      {
        amount: splitAdministrationAmount,
        costCenter: courseAttributes.registrationFee,
        causal: 'QUOTA_ISCRIZIONE',
      },
    ];
  });
};
